<template lang="pug">
    model-form(
        v-bind="formProps"
        v-model="formData"
        no-buttons
    )
        branch-offices-list(
            :items='items'
            no-edit
            slot='append'
        )
</template>

<script>
//
import { ModelForm } from '@/components/reusable_components/next'
import { BranchOfficesList } from '@/components/lists'
import CustomerService from '@/services/api/customer'
import CustomerDetailFields from './forms/fields/CustomerDetailFields.js'
//
export default {
    components: {
        'model-form': ModelForm,
        'branch-offices-list': BranchOfficesList,
    },
    data() {
        return {
            formData: {},
            fields: CustomerDetailFields,
            items: [],
            // loading: false,
        }
    },
    computed: {
        //-
        formProps() {
            return {
                fields: this.fields,
                editable: false,
                switchEdit: false,
                readOnly: true,
            }
        },
    },
    methods: {
        /**
         *
         */
        setFormData: function(model) {
            this.formData = model
            this.items = model.branch_offices
            this.items = [...this.items]
        },

        /**
         *
         */
        reset() {
            CustomerService.findById(this.$route.params.id).then(
                this.setFormData
            )
        },
    },
    beforeMount() {
        this.reset()
    },
}
</script>
